import useStores from 'shared/hooks/use-stores';
export default function useUser() {
    var User = useStores().User;
    return User;
}
